// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3_bCY","content":"GlobalSearch_content__3j6ud"};